import React from 'react';
import { PropTypes } from 'prop-types';
import { withRouter } from 'react-router';
import FlatButton from 'material-ui/FlatButton';
import excludeRouterKeys from './utilities/excludeRouterKeys';

const FlatButtonLink = props => {
  const { to, router } = props;
  const toFunc = to instanceof Function ? to : () => router.push(to);

  return <FlatButton {...excludeRouterKeys(props)} onClick={toFunc} />;
};

FlatButtonLink.propTypes = {
  to: PropTypes.oneOfType([PropTypes.string, PropTypes.func]).isRequired,
  label: PropTypes.string.isRequired,
  router: PropTypes.object.isRequired
};

export default withRouter(FlatButtonLink);



// WEBPACK FOOTER //
// ./src/components/FlatButtonLink.js